import { ResultStateRoot, ResultStateIcon, ResultStateContent, ResultStateTitle, ResultStateDescription, ResultStateActions } from './result-state-primitives';

export const ResultState = {
  get Root() {
    return ResultStateRoot;
  },
  get Icon() {
    return ResultStateIcon;
  },
  get Content() {
    return ResultStateContent;
  },
  get Title() {
    return ResultStateTitle;
  },
  get Description() {
    return ResultStateDescription;
  },
  get Actions() {
    return ResultStateActions;
  },
};
